export interface ValueLabelBox {
  x: number;
  y: number;
  width: number;
  height: number;
  barX: number;
  barY: number;
  barWidth: number;
  barHeight: number;
  kind: 'current' | 'predicted';
  visible: boolean;
  inside: boolean;
}
export interface PlotBounds {
  left: number;
  top: number;
  right: number;
  bottom: number;
}

export const labelsOverlap = (a: ValueLabelBox, b: ValueLabelBox, gap = 2) =>
  a.visible &&
  b.visible &&
  Math.min(a.x + a.width / 2, b.x + b.width / 2) + gap > Math.max(a.x - a.width / 2, b.x - b.width / 2) &&
  Math.min(a.y + a.height / 2, b.y + b.height / 2) + gap > Math.max(a.y - a.height / 2, b.y - b.height / 2);

/** Use measured text sizes, place within the plot, then resolve all pairs including neighbouring slots. */
export function layoutValueLabels(input: ValueLabelBox[], bounds: PlotBounds): ValueLabelBox[] {
  const labels = input.map((p) => {
    const inside = p.width + 4 <= Math.abs(p.barWidth) && p.height + 4 <= Math.abs(p.barHeight);
    const x = Math.max(bounds.left + p.width / 2, Math.min(p.barX + p.barWidth / 2, bounds.right - p.width / 2));
    const y = inside ? p.barY + p.barHeight / 2 : Math.max(bounds.top + p.height / 2, p.barY - p.height / 2 - 3);
    return { ...p, inside, x, y, visible: p.width <= bounds.right - bounds.left && y + p.height / 2 <= bounds.bottom };
  });
  for (let attempts = 0; attempts < labels.length * labels.length * 2; attempts++) {
    let conflict: [ValueLabelBox, ValueLabelBox] | undefined;
    for (let i = 0; i < labels.length && !conflict; i++)
      for (let j = i + 1; j < labels.length; j++) {
        if (labelsOverlap(labels[i], labels[j])) {
          conflict = [labels[i], labels[j]];
          break;
        }
      }
    if (!conflict) break;
    const [a, b] = conflict;
    const higher = a.barY < b.barY ? a : b;
    const lower = higher === a ? b : a;
    const raised = Math.min(higher.y, lower.y) - lower.height / 2 - higher.height / 2 - 2;
    if (raised - higher.height / 2 >= bounds.top) {
      higher.y = raised;
      higher.inside = false;
    } else {
      const hide = a.kind === 'current' ? a : b.kind === 'current' ? b : lower;
      hide.visible = false;
    }
  }
  return labels;
}
